module.exports = __webpack_public_path__ + "img/2_23.09.14_2131_S19ASQN_R2_01.86c6a69a.jpg";